// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"_8-ZM0"};